import React from 'react'
import {Divider} from 'wix-ui-tpa'
import {classes} from './divider.st.css'

export const DividerExt = props => <Divider {...props} className={classes.root} />
